/**
 * Countries shown in the phone-number country picker.
 *
 * Tuned for an Italian Piedmont-area gardening business: Italy is
 * the default, the rest are immediate neighbors and common expat
 * origins. Flags are Unicode Regional Indicator Symbols.
 *
 * The `code` field is the ISO 3166-1 alpha-2 code that libphonenumber-js
 * uses as `defaultRegion`. `validFirstDigits` is only meaningful for
 * countries where we want country-specific inline errors (currently
 * just Italy).
 */

import type { CountryOption } from './types'

export const COUNTRY_OPTIONS: CountryOption[] = [
  { code: 'IT', dialCode: '+39',  flag: '🇮🇹', label: 'Italia',      example: '333 333 3333',  maxNationalDigits: 11, validFirstDigits: ['0', '3'] },
  { code: 'CH', dialCode: '+41',  flag: '🇨🇭', label: 'Svizzera',    example: '76 123 45 67',  maxNationalDigits: 9 },
  { code: 'FR', dialCode: '+33',  flag: '🇫🇷', label: 'Francia',     example: '6 12 34 56 78', maxNationalDigits: 9 },
  { code: 'DE', dialCode: '+49',  flag: '🇩🇪', label: 'Germania',    example: '151 12345678',  maxNationalDigits: 11 },
  { code: 'AT', dialCode: '+43',  flag: '🇦🇹', label: 'Austria',     example: '664 1234567',   maxNationalDigits: 13 },
  { code: 'ES', dialCode: '+34',  flag: '🇪🇸', label: 'Spagna',      example: '612 34 56 78',  maxNationalDigits: 9 },
  { code: 'SM', dialCode: '+378', flag: '🇸🇲', label: 'San Marino',  example: '66 66 12 12',   maxNationalDigits: 10 },
  { code: 'GB', dialCode: '+44',  flag: '🇬🇧', label: 'Regno Unito', example: '7400 123456',   maxNationalDigits: 10 },
  { code: 'US', dialCode: '+1',   flag: '🇺🇸', label: 'Stati Uniti', example: '201 555 0123',  maxNationalDigits: 10 },
]

/** Default country used when none is selected (first entry = Italy). */
export const DEFAULT_COUNTRY: CountryOption = COUNTRY_OPTIONS[0]

/** Look up a CountryOption by its ISO code, falling back to Italy. */
export function getCountryByCode(code: string): CountryOption {
  return COUNTRY_OPTIONS.find((c) => c.code === code) || DEFAULT_COUNTRY
}
